import { render } from "./Asr.vue?vue&type=template&id=c1f12ffe"
import script from "./Asr.vue?vue&type=script&lang=js"
export * from "./Asr.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__